export default __webpack_public_path__ + "static/media/bti-title-cn.4904b346.webp";